<template>
  <section class="slider">
    <label class="title">{{ options.title }}</label>
    <div class="slider-container">
      <span class="slider-label left">{{ values[0] }}</span>
      <span class="slider-label right">{{ values[values.length - 1] }}</span>
      <range-slider
        class="range-slider"
        min="0"
        :max="values.length - 1"
        v-model="sliderValue"
        @change="setValue"
        :style="{
          width: values.length * 35 - 38 + 'px'
        }"
      >
        <template #knob>
          <div class="inner-knob">
            {{ values[sliderValue] }}
          </div>
        </template>
      </range-slider>
    </div>
  </section>
</template>

<script>
import { RangeSlider } from '@/plugins/vue-range-slider'

export default {
  props: ['options', 'value'],
  data() {
    return {
      values: Object.values(this.options.values),
      sliderValue: ''
    }
  },
  components: {
    RangeSlider
  },
  methods: {
    setValue() {
      this.$emit(
        'set-val',
        this.options.title,
        this.values[this.sliderValue],
        this.options.property,
        Object.keys(this.options.values).find(
          (key) => this.options.values[key] === this.values[this.sliderValue]
        )
      )
    }
  },
  mounted() {
    if (this.values.length) {
      this.sliderValue = this.values.indexOf(this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.slider {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.slider-container {
  position: relative;
}

.range-slider {
  height: 38px;
  margin-left: 19px;
  margin-right: 20px;
}

label {
  margin-right: 10px;
  padding-bottom: 4px;
}

.slider-label {
  position: absolute;
  top: 14px;
  line-height: 1;

  &.left {
    left: 3px;
  }

  &.right {
    right: 5px;
  }
}

.inner-knob {
  font-size: 11px;
  line-height: 36px;
}
</style>
